// src/config/settingsTabs.js
//
// Les 2 onglets de configuration communs à tous les comptes
// (indépendants des permissions de modules) : Modèles de documents & Connecteurs.
// Reprend les mêmes routes que SETTINGS_ITEMS dans
// src/components/layout/Navbar.js, avec une description un peu plus
// détaillée pour la visite guidée.

import { LayoutTemplate, Plug } from 'lucide-react';

export const SETTINGS_TABS = [
  {
    key:   'settings_templates',
    title: 'Modèles de documents',
    desc:  "Personnalisez les modèles utilisés pour générer vos dossiers de compétences, afin qu'ils reflètent votre charte graphique.",
    path:  '/settings/templates',
    Icon:  LayoutTemplate,
    color: 'indigo',
  },
  {
    key:   'settings_connectors',
    title: 'Connecteurs',
    desc:  'Connectez BoondManager, HubSpot ou MyHubConsulting pour synchroniser automatiquement vos données avec CVtoSkill.',
    path:  '/settings/boondmanager',
    Icon:  Plug,
    color: 'cyan',
  },
];